<template>
 <div>
      <!-- <el-button
      @click="daochu"
      type="primary"
      style="background: #f78989; border-color: #f78989; margin-bottom: 20px"
      >导出</el-button
    > -->
    <el-table :data="list" border style="width: 100%;margin-bottom:20px;" stripe @row-dblclick="handleCheckOverBooking">
    <el-table-column prop="installType" label="客户订单号"> </el-table-column>
    <el-table-column prop="orderNum" label="IMS订单号"> </el-table-column>
    <el-table-column prop="deliveryOrgName" label="库存组织"> </el-table-column>
    <el-table-column prop="orderTypeName" label="订单类型"> </el-table-column>
    <el-table-column prop="orderDate" label="提交日期"> </el-table-column>
    <el-table-column prop="customerName" label="下单客户名"> </el-table-column>
    <el-table-column prop="invoiceCustomerName" label="开票客户名"> </el-table-column>
    <el-table-column prop="statusName" label="状态"> </el-table-column>
    <el-table-column prop="priceName" label="价格单名称"> </el-table-column>
    <el-table-column prop="contractCode" label="合同号"> </el-table-column>
    <el-table-column prop="valuationTypeName" label="计价方式"> </el-table-column>
    <el-table-column prop="totalBox" label="箱数"> </el-table-column>
    <el-table-column prop="totalWeight" label="重量"> </el-table-column>
    <el-table-column prop="sumAmount" label="总计金额"> </el-table-column>
    <el-table-column prop="discount" label="市场折扣率"> </el-table-column>
    <el-table-column prop="discountAmount" label="市场折扣额"> </el-table-column>
    <el-table-column prop="jingAmount" label="净额"> </el-table-column>
    <el-table-column prop="deliveryDate" label="生产完成日期"> </el-table-column>
    <el-table-column prop="customerContact" label="收货联系人"> </el-table-column>
    <el-table-column prop="contactTel" label="收货联系人电话"> </el-table-column>
    <el-table-column prop="isDeferred" label="生产是否下发"> </el-table-column>
    <el-table-column prop="orderFreeze" label="是否发货"> </el-table-column>
    <el-table-column prop="lastUpdatedName" label="客服经理"> </el-table-column>
  </el-table>
  <el-pagination
    :current-page="pageNo"
    :page-size="pageSize"
    background
    layout="prev, pager, next, jumper"
    :total="rowCount"
    @current-change="handleCurrentChange"
  />
 </div>
</template>

<script>
export default {
  created() {
    this.getList()
  },
      methods:{
        getList() {
          this.$axios
            .postReq("/meide/REST/ajaxQueryOrderDetail", {
              postType: "query",
              start: this.pageNo,
              limit: this.pageSize
            })
            .then((res) => {
              this.list = res.data;
              this.rowCount = res.rowcount;
            });
        },
        handleCurrentChange(val) {
          this.pageNo = val;
          this.getList();
        },
        handleCheckOverBooking(item) {
          const path = this.$router.resolve({
            name: "OverBookingPro",
            params:{
              id:item.orderId
            }
          });
          window.open(path.href, "_blank");
        },
    //       daochu() {
    // let invoiceSeq = this.$route.params.id;
    //   this.$axios
    //     .postReq("/meide/REST/ajaxOrderExport", {
    //       postType: "exportInvoiceDetail",
    //       invoiceSeq,
    //     })
    //     .then((res) => {
    //       if (res.success == "true") {
    //         let url = res.url;
    //         window.open(url);
    //       } else {
    //         // this.$message.error(res.ErrorText);
    //       }
    //     });
    // },
    },
  data() {
    return {
      list: [],
      pageNo: 1,
      pageSize: 10,
      rowCount: 0,
    };
  },
};
</script>